import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Kpi } from '@masar/common/models';
import { permissionList } from '@masar/common/constants';

@Component({
    selector: 'app-kpi-link',
    templateUrl: './kpi-link.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class KpiLinkComponent {
    @Input() public item: Kpi;
    public permissionList = permissionList;
}
